import { useNavigate } from "react-router-dom";
import { ThemeToggle } from "../atoms/ThemeToggle.tsx";
import { Button } from "../atoms/Button.tsx";
import { useAuth } from "../../lib/auth.tsx";

export function TopBar({ title }: { title: string }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="topbar">
      <h1>{title}</h1>
      <div className="topbar-actions">
        <ThemeToggle />
        <Button size="sm" onClick={onLogout}>
          Log out
        </Button>
      </div>
    </header>
  );
}
